package co.maytes.standupbot.dashboard.pages.app

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.layout.AppShell
import co.maytes.standupbot.dashboard.components.layout.AuthGuard
import co.maytes.standupbot.dashboard.components.layout.ShellGround
import co.maytes.standupbot.dashboard.features.home.HomeScreen
import com.varabyte.kobweb.core.Page

@Page("/app")
@Composable
fun AppHomePage() = AuthGuard {
    AppShell(ground = ShellGround.Canvas) {
        HomeScreen()
    }
}
